import {
  Button,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Pagination,
  Popover,
  Radio,
  Row,
  Select,
  Table,
} from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import customerApi from '../../api/customer.api'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import { CustomDateButtonRadioTheme } from '../../styles/CustomAntdTheme'
import styles from '../../styles/customer.module.scss'
// import { CustomerAPIResponseMapper } from '../../utils/CustomerListMapper'
import Swal from 'sweetalert2'
import { issueUserTicket } from '../../api/community.api'
import statusUtil from '../../utils/status'
// import Customer from '../../utils/Customer'

const CustomerListPage = () => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(true)
  const [searchOptions, setSearchOptions] = useState({
    searchType: 'total',
    searchValue: null,
    memberType: 'general',
    dateType: 'total',
    startDate: null,
    endDate: null,
    signupReferralCode: null,
    libreStatus: null,
    ticketStatus: null,
    recentPaidProductCategory: null,
    recentPaidProductCategoryData: {
      product_type: null,
      category_id: null,
    },
  })
  const [orderType, setOrderType] = useState('created_at')
  const [orderBy, setOrderBy] = useState('desc')
  const [totalSize, setTotalSize] = useState(0)
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [memberList, setMemberList] = useState([])
  const [selectMember, setSelectMember] = useState({})
  const [isPointModalOpen, setIsPointModalOpen] = useState(false)
  const [pointHistory, setPointHistory] = useState({
    earn: 0,
    usage: 0,
    list: [],
  })
  const [isEarnPointPopoverOpen, setIsEarnPointPopoverOpen] = useState(false)
  const [earnPoint, setEarnPoint] = useState({
    pointContent: null,
    pointScore: null,
  })
  const [isMemberManageModalOpen, setIsMemberManageModalOpen] = useState({
    visible: false,
    type: null,
  })
  const [password, setPassword] = useState(null)
  // const [expertList, setExpertList] = useState([])
  // const [channelJoinShow, setChannelJoinShow] = useState(false)
  const [navType, setNavType] = useState('mall') // mall, app
  const [selectedRowKey, setSelectedRowKey] = useState([])
  const [selectedRow, setSelectedRow] = useState([])

  const recentPaidProductCategory = [
    {
      label: '전체',
      value: null,
      data: { product_type: null, category_id: null },
    },
    {
      label: '스캔 체험단',
      value: 'SCAN_EXPERIMENT',
      data: {
        product_type: 'ETC',
        category_id: 'glucometer',
      },
    },
    {
      label: 'CGM',
      value: 'CGM',
      data: {
        product_type: 'MEDICAL_DEVICE',
        category_id: 'glucometer',
      },
    },
    {
      label: '영양제',
      value: 'HEALTH_FUNCTIONAL_FOOD',
      data: {
        product_type: 'HEALTH_FUNCTIONAL_FOOD',
        category_id: null,
      },
    },
  ]

  // const [memberTypeItems, setMemberTypeItems] = useState([
  //   { label: '일반', value: 'general' },
  //   { label: '임직원', value: 'admin' },
  // ])
  const [searchTypeItems, setSearchTypeItems] = useState([
    { searchType: 'total', searchText: '전체검색' },
    { searchType: 'id', searchText: '아이디' },
    { searchType: 'nickname', searchText: '닉네임' },
    { searchType: 'phone', searchText: '연락처' },
  ])

  const dateTypeItems = [
    { label: '전체', value: 'total' },
    { label: '오늘', value: 'today' },
    { label: '1주일', value: '1week' },
    { label: '1개월', value: '1month' },
    { label: '3개월', value: '3month' },
  ]

  const orderPair = {
    id: '회원번호순',
    name: '닉네임순',
    mallPoint: '보유포인트순',
    created_at: '가입일순',
  }

  const signupReferralCodeItems = [
    { label: '전체', value: null },
    { label: '인스타그램', value: 'INSTA' },
    { label: '유튜브', value: 'YOUTUBE' },
    { label: '홈페이지', value: 'SUGAR_HOME_PAGE' },
  ]

  const libreStatusItems = [
    { label: '전체', value: null },
    { label: '연동 중', value: 'CONNECTING' },
    { label: '연동 이력 존재', value: 'CONNECTED' },
  ]

  const ticketStatusItems = [
    { label: '전체', value: null },
    { label: '사용완료', value: 'USED' },
    { label: '미사용', value: 'NOT_USED' },
    { label: '사용중', value: 'IN_USE' },
  ]

  // const rowSelection = {
  //   selectedRowKeys: selectedRowKey,
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     // for (const row of selectedRows) {
  //     // 	if (!editDeliveryInfo.hasOwnProperty(row.order_detail_id)) {
  //     // 		editDeliveryInfo[row.order_detail_id] = {
  //     // 			order_id: row.order_id,
  //     // 			order_detail_id: row.order_detail_id,
  //     // 			order_detail_status: "delivery_shipping",
  //     // 			delivery_company: row.delivery_company,
  //     // 			tracking_number: row.tracking_number,
  //     // 			ship_date:
  //     // 				row.ship_date === null || row.ship_date === ""
  //     // 					? dayjs()
  //     // 					: dayjs(row.ship_date),
  //     // 			updated_by: user.id === 724 ? 1 : user.id,
  //     // 		};
  //     // 	}
  //     // }
  //     // let difference = Object.keys(editDeliveryInfo).filter(
  //     // 	(orderDetailKey) => !selectedRowKeys.includes(parseInt(orderDetailKey))
  //     // );
  //     // if (difference?.length !== 0) {
  //     // 	for (const orderDetailKey of difference) {
  //     // 		delete editDeliveryInfo[orderDetailKey];
  //     // 	}
  //     // }
  //     setSelectedRowKey(selectedRowKeys)
  //     setSelectedRow(selectedRows)
  //   },
  // }

  const columns = [
    {
      title: '회원번호',
      // width: 120,
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      // ellipsis: true,
      sorter: (a, b) => {},
    },
    {
      title: '닉네임',
      // width: 120,
      dataIndex: 'name',
      key: 'name',
      // ellipsis: true
      sorter: (a, b) => {},
    },
    {
      title: '가입상태',
      // width: 120,
      dataIndex: 'provider',
      key: 'provider',
      // ellipsis: true
      render: (value) => {
        if (value) {
          return statusUtil.matchingProvider[value]
        } else {
          return '휴대폰로그인'
        }
      },
    },
    {
      title: '휴대폰 번호',
      // width: 120,
      dataIndex: 'phone',
      key: 'phone',
      // ellipsis: true
    },
    // {
    //   title: '골드',
    //   // width: 120,
    //   dataIndex: 'gold',
    //   key: 'gold',
    //   // ellipsis: true
    //   sorter: (a, b) => {},
    //   render: (value) => {
    //     return value?.toLocaleString() + 'G'
    //   },
    // },
    {
      title: '포인트',
      // width: 120,
      dataIndex: 'mall_point',
      key: 'mall_point',
      // ellipsis: true
      sorter: (a, b) => {},
      render: (value, record) => {
        if (value) {
          return (
            <span
              className="member-search-table-highlight"
              onClick={() => {
                getPointHistoryListById(record.id)
                setSelectMember(record)
                setIsPointModalOpen(true)
              }}
            >
              {value.toLocaleString()}
            </span>
          )
        } else {
          return (
            <span
              className="member-search-table-highlight"
              onClick={() => {
                getPointHistoryListById(record.id)
                setSelectMember(record)
                setIsPointModalOpen(true)
              }}
            >
              0
            </span>
          )
        }
      },
    },
    // {
    //   title: '임직원 여부',
    //   // width: 120,
    //   dataIndex: 'is_admin',
    //   key: 'is_admin',
    //   // ellipsis: true
    //   render: (value) => {
    //     return value ? '임직원' : ''
    //   },
    // },
    {
      title: '가입일',
      // width: 120,
      dataIndex: 'created_at',
      key: 'created_at',
      // ellipsis: true
      sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return dayjs(value).format('YYYY.MM.DD')
        }
      },
    },
    {
      title: '최종접속일',
      // width: 120,
      dataIndex: 'updated_at',
      key: 'updated_at',
      // ellipsis: true
      render: (value, record) => {
        if (value) {
          return dayjs(value).format('YYYY.MM.DD')
        } else if (record.created_at) {
          return dayjs(record.created_at).format('YYYY.MM.DD')
        }
      },
    },
    // {
    //   title: '회원관리',
    //   // width: 120,
    //   dataIndex: '',
    //   key: '',
    //   // ellipsis: true
    //   render: (value, record) => {
    //     return (
    //       <Row wrap={false} align="middle">
    //         <Button
    //           onClick={() => {
    //             setSelectMember(record)
    //             setIsMemberManageModalOpen({ visible: true, type: 'withdraw' })
    //           }}
    //         >
    //           회원탈퇴
    //         </Button>
    //         {record.is_admin ? (
    //           <Button
    //             onClick={() => {
    //               setSelectMember(record)
    //               setIsMemberManageModalOpen({
    //                 visible: true,
    //                 type: 'disallow',
    //               })
    //             }}
    //           >
    //             관리자 탈퇴
    //           </Button>
    //         ) : (
    //           <Button
    //             onClick={() => {
    //               setSelectMember(record)
    //               setIsMemberManageModalOpen({ visible: true, type: 'allow' })
    //             }}
    //           >
    //             관리자 등록
    //           </Button>
    //         )}
    //       </Row>
    //     )
    //   },
    // },
    {
      title: '리브레 연동 중',
      // width: 120,
      dataIndex: 'libre_email',
      key: 'libre_email',
      // sorter: (a, b) => {},
      render: (value) => {
        return value ? '연동' : '-'
      },
    },
    {
      title: '리브레 연동 이력',
      // width: 120,
      dataIndex: 'libre_email_history',
      key: 'libre_email_history',
      // sorter: (a, b) => {},
      render: (value) => {
        return value ? '존재' : '-'
      },
    },
    {
      title: '가입 경로',
      width: 120,
      dataIndex: 'signup_referral_code',
      key: 'signup_referral_code',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value, record) => {
        const code = record.signup_referral_code
        if (!code) {
          return '-'
        }
        switch (code) {
          case 'INSTA':
            return '인스타그램'
          case 'YOUTUBE':
            return '유튜브'
          case 'SUGAR_HOME_PAGE':
            return '홈페이지'
          default:
            return code
        }
      },
    },
    {
      title: '스캔 이용 상태',
      width: 120,
      dataIndex: 'ticketStatus',
      key: 'ticketStatus',
      ellipsis: true,
      render: (value) => {
        switch (value) {
          case 'USED':
            return '사용완료'
          case 'NOT_USED':
            return '미사용'
          case 'IN_USE':
            return '사용중'
          default:
            return '-'
        }
      },
    },
    {
      title: '스캔 종료 기한',
      width: 120,
      dataIndex: 'ticketRecentUsedTime',
      key: 'ticketRecentUsedTime',
      ellipsis: true,
      render: (value) => {
        if (value) {
          return dayjs(value).format('YYYY.MM.DD')
        } else {
          return '-'
        }
      },
    },
    {
      title: '최근 구매 상품명',
      width: 120,
      dataIndex: 'recentPaidProductName',
      key: 'recentPaidProductName',
      ellipsis: true,
      render: (value) => {
        return value || '-'
      },
    },
    {
      title: '최근 구매 일자',
      width: 120,
      dataIndex: 'recentPaidDateTime',
      key: 'recentPaidDateTime',
      ellipsis: true,
      render: (value) => {
        if (value) {
          return dayjs(value).format('YYYY.MM.DD')
        } else {
          return '-'
        }
      },
    },
  ]

  const pointColumns = [
    {
      title: '일시',
      width: 160,
      dataIndex: 'createdAt',
      key: 'createdAt',
      // ellipsis: true
      render: (value) => {
        if (value) {
          return dayjs(value).format('YYYY.MM.DD')
        }
      },
    },
    {
      title: '내용',
      // width: 120,
      dataIndex: 'pointType',
      key: 'pointType',
      // ellipsis: true
      render: (value, record) => {
        if (value.includes('ADMIN')) {
          return record.pointContent
        } else if (statusUtil.matchingPointHistory.hasOwnProperty(value)) {
          return statusUtil.matchingPointHistory[value]
        } else {
          return value
        }
      },
    },
    {
      title: '지급 포인트',
      width: 208,
      dataIndex: '',
      key: '',
      // ellipsis: true
      render: (_, record) => {
        if (
          record.pointType === 'PURCHASE_COMPLETE' ||
          record.pointType === 'REVIEW_COMPLETE' ||
          record.pointType === 'ADMIN_POINT_COMPLETE' ||
          record.pointType === 'PURCHASE_CANCEL'
        ) {
          return record.pointScore.toLocaleString()
        } else {
          return '-'
        }
      },
    },
    {
      title: '사용 포인트',
      width: 208,
      dataIndex: '',
      key: '',
      // ellipsis: true
      render: (_, record) => {
        if (
          record.pointType !== 'PURCHASE_COMPLETE' &&
          record.pointType !== 'REVIEW_COMPLETE' &&
          record.pointType !== 'ADMIN_POINT_COMPLETE' &&
          record.pointType !== 'PURCHASE_CANCEL'
        ) {
          return record.pointScore.toLocaleString()
        } else {
          return '-'
        }
      },
    },
  ]

  useEffect(() => {
    if (navType === 'mall') {
      getReadMemberList()
    }
  }, [offset, pageSize, orderType, orderBy])

  const getReadMemberList = async (type = '') => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          searchType: searchTypeItems[0].searchType,
          searchValue: null,
          startDate: null,
          endDate: null,
          orderType: 'created_at',
          orderBy: 'desc',
          signupReferralCode: null,
          libreConnected: null,
          productType:
            searchOptions.recentPaidProductCategoryData?.product_type,
          categoryId: searchOptions.recentPaidProductCategoryData?.category_id,
          programTicketStatus: searchOptions.ticketStatus,
        }
      } else if (type === 'search') {
        param = {
          offset: 0,
          pageSize: 10,
          searchType: searchOptions.searchType,
          searchValue: searchOptions.searchValue,
          startDate: searchOptions.startDate
            ? searchOptions.startDate.format('YYYY-MM-DD')
            : null,
          endDate: searchOptions.endDate
            ? searchOptions.endDate.format('YYYY-MM-DD')
            : null,
          orderType: orderType,
          orderBy: orderBy,
          signupReferralCode: searchOptions.signupReferralCode,
          libreConnected: searchOptions.libreStatus,
          productType:
            searchOptions.recentPaidProductCategoryData?.product_type,
          categoryId: searchOptions.recentPaidProductCategoryData?.category_id,
          programTicketStatus: searchOptions.ticketStatus,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          searchType: searchOptions.searchType,
          searchValue: searchOptions.searchValue,
          startDate: searchOptions.startDate
            ? searchOptions.startDate.format('YYYY-MM-DD')
            : null,
          endDate: searchOptions.endDate
            ? searchOptions.endDate.format('YYYY-MM-DD')
            : null,
          orderType: orderType,
          orderBy: orderBy,
          signupReferralCode: searchOptions.signupReferralCode,
          libreConnected: searchOptions.libreStatus,
          productType:
            searchOptions.recentPaidProductCategoryData?.product_type,
          categoryId: searchOptions.recentPaidProductCategoryData?.category_id,
          programTicketStatus: searchOptions.ticketStatus,
        }
      }

      const res = await customerApi.readCustomerList(param, user.id)
      if (res.data.code === 200) {
        setMemberList(
          res.data.result.userList.flatMap((user) => ({
            ...user.user,
            ...(user.userOrderByProductCategory || {}),
            ...(user.userTicket || {}),
          })),
        )
        setTotalSize(res.data.result.totalCnt)
      } else {
        alert(
          '회원 목록을 조회해오지 못하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      setMemberList([])
      setTotalSize(0)
      console.log('getReadMemberList read error', error)
    }
  }

  const getPointHistoryListById = async (userId) => {
    setIsLoading(true)
    try {
      const param = {
        userId: userId,
      }
      const res = await customerApi.readMemberPointHistoryList(param, user.id)
      if (res.data.code === 200) {
        let earnPoint = 0
        let usagePoint = 0
        for (const history of res.data.result) {
          if (
            history.pointType === 'PURCHASE_COMPLETE' ||
            history.pointType === 'REVIEW_COMPLETE' ||
            history.pointType === 'ADMIN_POINT_COMPLETE' ||
            history.pointType === 'PURCHASE_CANCEL'
          ) {
            earnPoint += history.pointScore
          } else {
            usagePoint += history.pointScore
          }
        }
        setPointHistory({
          earn: earnPoint,
          usage: usagePoint,
          list: res.data.result,
        })
      } else {
        alert(
          '해당 회원의 포인트 상세 내역을 읽어오지 못하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getPointHistoryListById read error', error)
    }
  }

  /**
   * 회원 포인트 개별 발급
   */
  const handleEarnPoint = async () => {
    if (
      window.confirm(`${selectMember.name}님께 포인트 발급을 진행하시겠습니까?`)
    ) {
      setIsLoading(true)
      try {
        const param = {
          ...earnPoint,
          userId: selectMember.id,
          createdBy: user.id,
        }
        const res = await customerApi.earnPointForMember(param)
        if (res.data.code === 200) {
          setIsLoading(false)
          alert(`${selectMember.name}님에게 포인트 발급을 완료하였습니다.`)
          handlePopoverHide()
          getPointHistoryListById(selectMember.id)
        } else if (res.data.code === 999) {
          throw '현재 로그인한 계정으로 해당 작업을 진행할 수 있는 권한이 없습니다.\n다른 관리자 계정으로 로그인해주시거나 관리자에게 문의해주시길 바랍니다.'
        } else {
          throw res.data.msg
        }
      } catch (error) {
        setIsLoading(false)
        console.log('handleEarnPoint publish error', error)
        alert(error)
      }
    }
  }

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value
    switch (value) {
      case 'total':
        setSearchOptions({
          ...searchOptions,
          dateType: value,
          startDate: null,
          endDate: null,
        })
        break
      case 'today':
        setSearchOptions({
          ...searchOptions,
          dateType: value,
          startDate: dayjs().startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '1week':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: dayjs().subtract(7, 'days').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(7, 'days')
              .startOf('day'),
          })
        }
        break
      case '1month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: dayjs().subtract(1, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(1, 'months')
              .startOf('day'),
          })
        }
        break
      case '3month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: dayjs().subtract(3, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(3, 'months')
              .startOf('day'),
          })
        }
        break
    }
  }

  /**
   * 검색
   */
  const handleSearch = () => {
    if (searchOptions.dateType === 'total') {
      setOffset(0)
      setPageSize(10)
      setCurrentPageNumber(1)
      setSelectedRow([])
      setSelectedRowKey([])
      if (navType === 'mall') {
        getReadMemberList('search')
      }
    } else {
      if (searchOptions.startDate === null || searchOptions.endDate === null) {
        alert('조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.')
      } else {
        if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
          alert(
            '조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.',
          )
        } else {
          setOffset(0)
          setPageSize(10)
          setCurrentPageNumber(1)
          setSelectedRow([])
          setSelectedRowKey([])
          if (navType === 'mall') {
            getReadMemberList('search')
          }
        }
      }
    }
  }

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchTypeItems[0].searchType,
      searchText: null,
      // memberType: navType === 'mall' ? 'general' : 0,
      dateType: 'total',
      startDate: null,
      endDate: null,
      signupReferralCode: null,
    })
    setOffset(0)
    setPageSize(10)
    setCurrentPageNumber(1)
    if (navType === 'mall') {
      getReadMemberList('initial')
    }
  }

  const handleTableChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType('created_at')
        setOrderBy('desc')
      }
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber, pageSize) => {
    const offset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(offset)
    setPageSize(pageSize)
  }

  /**
   * 포인트 상세 내역 Modal cancel handler
   */
  const handleCancel = () => {
    setIsPointModalOpen(false)
    setSelectMember({})
    setPointHistory({
      earn: 0,
      usage: 0,
      list: [],
    })
    getReadMemberList()
  }

  /**
   * 개별 회원별 포인트 지급 Popover open handler
   */
  const handlePopoverOpenChange = (value) => {
    setIsEarnPointPopoverOpen(value)
    if (!value) {
      setEarnPoint({
        pointContent: null,
        pointScore: null,
      })
    }
  }

  /**
   * 개별 회원별 포인트 지급 Popover close handler
   */
  const handlePopoverHide = () => {
    setIsEarnPointPopoverOpen(false)
    setEarnPoint({
      pointContent: null,
      pointScore: null,
    })
  }

  /**
   * 회원 관리 Modal cancel handler
   */
  // const handleMemberManageModalCancel = () => {
  //   setIsMemberManageModalOpen({ ...isMemberManageModalOpen, visible: false })
  //   setSelectMember({})
  //   setPassword(null)
  // }

  // const disableUserChannelJoin = () => {
  //   return (
  //     !selectedRow?.length ||
  //     searchOptions.memberType !== 999 ||
  //     !notRegisterValid
  //   )
  // }

  // const selectUserChannelJoin = () => {
  //   setSelectMember([...selectedRow])
  //   setChannelJoinShow(true)
  // }

  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [form] = Form.useForm()

  /**
   *    발급
   */
  const openTicketModal = (record) => {
    setSelectedUser(record)

    form.setFieldsValue({
      userId: record.userId,
      programOptionId: 44, //2주권 고정
      quantity: 1,
      type: null,
    })
    setIsTicketModalOpen(true)
  }

  const handleTicketIssue = async () => {
    try {
      const values = await form.validateFields()

      // 발급 확인 팝업
      const result = await Swal.fire({
        title: '스캔권 발급 확인',
        text: `${selectedUser?.name || '사용자'}님에게 ${values.quantity}장 발급하시겠습니까?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '발급',
        cancelButtonText: '취소',
        reverseButtons: true,
      })

      if (!result.isConfirmed) {
        return
      }

      await issueUserTicket({
        userId: values.userId,
        programOptionId: values.programOptionId,
        quantity: values.quantity,
        issueType:
          values.type === 'issuedAfterCompletion'
            ? 'issuedAfterCompletion'
            : 'new',
      })
      message.success('스캔권이 발급되었습니다.')
      setIsTicketModalOpen(false)
      form.resetFields()
      setSelectedUser(null)
    } catch (error) {
      if (error.errorFields) {
        message.warning('모든 필드를 올바르게 입력해주세요.')
      } else {
        message.error('스캔권 발급에 실패했습니다.')
      }
    }
  }

  const handleTicketModalCancel = () => {
    setIsTicketModalOpen(false)
    form.resetFields()
    setSelectedUser(null)
  }

  return (
    <>
      <ContentHeader title="회원 관리" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '768px' }}
      >
        {/*회원 검색*/}
        <div className={`${styles['product-search-box-wrap']}`}>
          <Form.Item
            className={`${styles['center-label']}`}
            label="검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 200, textAlign: 'left' }}
            >
              {searchTypeItems.map((item, idx) => (
                <Select.Option
                  key={`search_type_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Select.Option>
              ))}
            </Select>
            <Input
              className={`${styles['inquiry-search-input-wrap']}`}
              placeholder="검색어를 입력하세요."
              name="searchValue"
              value={searchOptions.searchValue}
              onChange={(e) =>
                setSearchOptions({
                  ...searchOptions,
                  [e.target.name]: e.target.value,
                })
              }
              onPressEnter={handleSearch}
            />
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="가입일"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <ConfigProvider theme={CustomDateButtonRadioTheme}>
              <Row align={'middle'} style={{ gap: '5px' }}>
                <Radio.Group
                  className={`${styles['options-list']}`}
                  options={dateTypeItems}
                  onChange={handleDateTypeChange}
                  value={searchOptions.dateType}
                  optionType="button"
                />
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  allowClear={false}
                  value={searchOptions.startDate}
                  disabled={searchOptions.dateType === 'total'}
                  onChange={(value) => {
                    setSearchOptions({
                      ...searchOptions,
                      dateType: null,
                      startDate: value,
                    })
                  }}
                />
                ~
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  allowClear={false}
                  value={searchOptions.endDate}
                  disabled={searchOptions.dateType === 'total'}
                  onChange={(value) => {
                    setSearchOptions({
                      ...searchOptions,
                      dateType: null,
                      endDate: value,
                    })
                  }}
                />
              </Row>
            </ConfigProvider>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />

          <Form.Item
            className={`${styles['center-label']}`}
            label="가입 경로"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              name="signupReferralCode"
              value={searchOptions.signupReferralCode}
              options={signupReferralCodeItems}
              onChange={(e) => {
                setSearchOptions({
                  ...searchOptions,
                  signupReferralCode: e.target.value,
                })
              }}
            />
          </Form.Item>

          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />

          <Form.Item
            className={`${styles['center-label']}`}
            label="리브레 연동 상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              name="libreStatus"
              value={searchOptions.libreStatus}
              options={libreStatusItems}
              onChange={(e) => {
                setSearchOptions({
                  ...searchOptions,
                  libreStatus: e.target.value,
                })
              }}
            />
          </Form.Item>

          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />

          <Form.Item
            className={`${styles['center-label']}`}
            label="스캔 이용 상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              name="ticketStatus"
              value={searchOptions.ticketStatus}
              options={ticketStatusItems}
              onChange={(e) => {
                setSearchOptions({
                  ...searchOptions,
                  ticketStatus: e.target.value,
                })
              }}
            />
          </Form.Item>

          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />

          <Form.Item
            className={`${styles['center-label']}`}
            label="최근 구매 상품 카테고리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              name="recentPaidProductCategory"
              value={searchOptions.recentPaidProductCategory}
              options={recentPaidProductCategory}
              onChange={(e) => {
                setSearchOptions({
                  ...searchOptions,
                  recentPaidProductCategory: e.target.value,
                  recentPaidProductCategoryData: recentPaidProductCategory.find(
                    (item) => item.value === e.target.value,
                  ).data,
                })
                console.log('searchOptions', searchOptions)
              }}
            />
          </Form.Item>

          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />

          <Row
            className={`${styles['review-search-button-wrap']}`}
            justify="center"
          >
            <Button
              className={`${styles['review-search-button']} ${styles.search}`}
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className={`${styles['review-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*회원 목록*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className={`${styles['product-register-box-title']}`}>
              회원 목록 (총{' '}
              <span
                className={`${styles['product-register-box-subtitle']}`}
                style={{ marginLeft: 0 }}
              >
                {totalSize ? totalSize?.toLocaleString() : 0}
              </span>
              개)
            </span>
            <span className={`${styles['product-list-subtitle']}`}>
              {orderPair[orderType]}
            </span>
          </div>
          {/*  스캔권 발급*/}
          <Button type="default" onClick={openTicketModal}>
            스캔권 발급
          </Button>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          <Table
            columns={columns}
            dataSource={memberList}
            loading={isLoading}
            tableLayout={'auto'}
            bordered
            size="middle"
            rowKey="id"
            rowClassName="coupon-table-row"
            scroll={{ x: 'max-content' }}
            onChange={handleTableChange}
            pagination={false}
          />

          <Pagination
            showSizeChanger
            current={currentPageNumber}
            pageSize={pageSize}
            total={totalSize}
            onChange={handleChangePagination}
            align="end"
            style={{ marginTop: 20 }}
          />
        </div>
      </div>

      {/*포인트 내역 Modal*/}
      {isPointModalOpen && (
        <Modal
          title="포인트 상세 내역"
          open={isPointModalOpen}
          centered={true}
          onCancel={handleCancel}
          width={'80%'}
          wrapClassName="member-point-modal-wrap"
          footer={null}
        >
          <Row wrap={false} justify="space-between" align="middle">
            <div className="member-point-modal-content-header">
              {selectMember.name} 님의 포인트 내역
            </div>
            <Popover
              overlayClassName="member-earn-point-popover-wrap"
              title=""
              trigger="click"
              placement="bottomRight"
              open={isEarnPointPopoverOpen}
              onOpenChange={handlePopoverOpenChange}
              content={
                <div className="member-earn-point-popover-content-wrap">
                  <Row wrap={false} justify="space-between" align="middle">
                    <div className="member-earn-point-popover-header">
                      회원 포인트 개별 발급
                    </div>
                    <img
                      className="member-earn-point-popover-close"
                      src={`${process.env.REACT_APP_HOST}/assets/icon/customer/close.png`}
                      onClick={handlePopoverHide}
                    />
                  </Row>
                  <div className="member-earn-point-popover-content">
                    <Form.Item
                      className="member-earn-point-form-wrap"
                      label="회원 아이디"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 8 }}
                    >
                      <Input value={selectMember.id} disabled={true} />
                    </Form.Item>
                    <Form.Item
                      className="member-earn-point-form-wrap"
                      label="회원 닉네임"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 8 }}
                    >
                      <Input value={selectMember.name} disabled={true} />
                    </Form.Item>
                    <Form.Item
                      className="member-earn-point-form-wrap"
                      label="포인트 내용"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                    >
                      <Input
                        placeholder="포인트 내용을 입력해주세요."
                        name="pointContent"
                        value={earnPoint.pointContent}
                        onChange={(e) =>
                          setEarnPoint({
                            ...earnPoint,
                            [e.target.name]: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      className="member-earn-point-form-wrap"
                      label="발급 포인트"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                    >
                      <Row wrap={false} align="middle">
                        <InputNumber
                          placeholder="숫자를 입력해주세요."
                          size="small"
                          formatter={(value) =>
                            value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          }
                          parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                          min={0}
                          value={earnPoint.pointScore}
                          onChange={(value) => {
                            setEarnPoint({ ...earnPoint, pointScore: value })
                          }}
                        />
                        <div className="member-earn-point-form-help-text">
                          POINT
                        </div>
                      </Row>
                    </Form.Item>
                  </div>
                  <Row
                    className="member-earn-point-button-wrap"
                    justify="center"
                  >
                    <Button
                      className="member-earn-point-button earn"
                      onClick={handleEarnPoint}
                      disabled={Object.values(earnPoint).some(
                        (value) => value === null || value === 0,
                      )}
                    >
                      발급
                    </Button>
                    <Button
                      className="member-earn-point-button cancel"
                      onClick={handlePopoverHide}
                    >
                      취소
                    </Button>
                  </Row>
                </div>
              }
            >
              <Button
                className="member-earn-point-button-wrap"
                onClick={() => handlePopoverOpenChange(true)}
              >
                포인트 발급
              </Button>
            </Popover>
          </Row>
          <Table
            className="member-point-history-table-wrap"
            columns={pointColumns}
            dataSource={pointHistory.list}
            loading={isLoading}
            tableLayout={'auto'}
            bordered
            size="small"
            rowKey="id"
            scroll={{ x: 'max-content', y: 'calc(600px - 48px)' }}
            pagination={false}
          />
          <div style={{ paddingRight: 15 }}>
            <Row wrap={false}>
              <Col
                className="member-point-history-total-wrap"
                flex="auto"
                style={{ borderRight: 0 }}
              >
                소계
              </Col>
              <Col
                className="member-point-history-total-wrap"
                flex="208px"
                style={{ borderRight: 0 }}
              >
                {pointHistory.earn.toLocaleString()}
              </Col>
              <Col className="member-point-history-total-wrap" flex="208px">
                {pointHistory.usage.toLocaleString()}
              </Col>
            </Row>
            <Row wrap={false}>
              <Col
                className="member-point-history-total-wrap"
                flex="auto"
                style={{ borderTop: 0, borderRight: 0 }}
              >
                총 보유 포인트
              </Col>
              <Col
                className="member-point-history-total-wrap"
                flex="416px"
                style={{ borderTop: 0 }}
              >
                {(pointHistory.earn - pointHistory.usage).toLocaleString()}
              </Col>
            </Row>
          </div>
        </Modal>
      )}
      {/* 스캔권 발급 관리 모달 */}
      <Modal
        title="스캔권 발급 관리"
        open={isTicketModalOpen}
        onOk={handleTicketIssue}
        onCancel={handleTicketModalCancel}
        okText="발급"
        cancelText="취소"
        width={500}
      >
        <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
          <Form.Item label="회원번호" name="userId">
            <Input />
          </Form.Item>

          <Form.Item label="프로그램 옵션 ID" name="programOptionId">
            <Input disabled />
          </Form.Item>

          <Form.Item
            label="발급 장수"
            name="quantity"
            rules={[
              { required: true, message: '발급 장수를 입력해주세요.' },
              {
                type: 'number',
                min: 1,
                message: '1 이상의 숫자를 입력해주세요.',
              },
            ]}
          >
            <InputNumber
              min={1}
              style={{ width: '100%' }}
              placeholder="발급할 스캔권 수량을 입력하세요"
            />
          </Form.Item>

          <Form.Item
            label="타입"
            name="type"
            rules={[{ required: true, message: '타입을 선택해주세요.' }]}
          >
            <Select placeholder="발급 타입을 선택하세요">
              <Select.Option value="issuedAfterCompletion">
                사용완료 처리 후 발급
              </Select.Option>
              <Select.Option value={'new'}>새로 발급</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
export default CustomerListPage
